import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'

import style from './header.sass'

@inject('store') @observer
class PnlByTickerHeader extends Component {
  render() {
    const {ticker_metrics} = this.props.store.backtest
    const ticker = this.props.ticker
    return(
      <div styleName='wrapper'>
        {ticker_metrics[ticker] && ticker_metrics[ticker].map(record => {
          const {name, ident, unit, value} = record
          if (['volatility', 'sharpe ratio', 'sortino ratio'].indexOf(name.toLowerCase()) === -1) {
            return(
              <div key={ident}>
                <h5 styleName='name'>{name}</h5>
                <p styleName='value'>
                  {unit.location === 'before' && unit.symbol}
                  {typeof value === 'number' && value.toFixed(2)}
                  {unit.location === 'after' && unit.symbol}
                </p>
              </div>
            )
          }
        })}
      </div>
    )
  }
}

export default PnlByTickerHeader
